// External
import _ from "lodash";

// Internal
import {
  getGpaAssociatedDataRating,
  getFormattedGpaAssociatedRatingValue,
} from "../ratingPrimitives";

export const getGpaCriteriaSet = ({ ratings, termId, criteriaSet }) => {
  // Get computed rating
  const computedRating = getGpaAssociatedDataRating({
    ratings,
    termId,
  });

  // Currently overriding the grade point rating is not supported
  // const overRidingRating = getGpaAssociatedDataRating({
  //   computedRating: false,
  //   ratings,
  //   subjectId,
  //   termId,
  // });

  const rating = computedRating;

  const value = _.get(rating, "value", "-");

  const formattedValue = getFormattedGpaAssociatedRatingValue(value);

  return {
    ...criteriaSet,
    value: formattedValue,
  };
};
